import React, { useState } from "react";
import Image from "components/image";

const AnnouncementBanner = ({ data: { announcementBanner } }) => {
    const [bannerOpen, setBanner] = useState(true);

    return (
        <div className={`overflow-hidden sticky h-fit ${bannerOpen ? "animate-to-full-height" : "animate-to-zero-height"} `}>
            <div className="element-as-bg">
                <Image className="w-full h-full" imgClassName="object-left" image={announcementBanner.bgImage.asset} />
            </div>
            <div tabIndex="0" role="button" onClick={() => setBanner(false)} onKeyDown={() => setBanner(false)} className="close-announcement-banner">
                ×
            </div>
            <div className="w-full py-2.5 h-full relative flex items-center justify-between lg:max-w-[67.5rem] m-auto max-w-xs">
                <div className="lg:w-60 w-32 lg:leading-9 leading-6 font-bold lg:text-h1 text-xl text-white">{announcementBanner.title}</div>
                <div className="lg:flex-row flex flex-col items-center lg:justify-between justify-center lg:gap-24">
                    <h3 className="lg:text-h3 text-yellow-600 font-bold text-sm"> 
                        {announcementBanner.subtitle}
                    </h3>
                    <h3 className="announcement-banner-cta"> 
                        {announcementBanner.ctaText}
                    </h3>
                </div>
            </div>
        </div>
    );
};

export default AnnouncementBanner;
